import { toast } from "@devhop/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  CreateFeeConfigInput,
  UpdateFeeConfigInput,
} from "@/modules/wallet/domain/repo/wallet-fee";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { walletFeeApi } from "./wallet-fee-client";

export const walletFeeKeys = {
  all: ["wallet-fee"] as const,
  list: (q: Partial<OffsetPageQueryDTO>) => ["wallet-fee", "list", q] as const,
  detail: (id: string) => ["wallet-fee", "detail", id] as const,
};

export function useWalletFeeListQuery(query: Partial<OffsetPageQueryDTO> = {}) {
  const q: OffsetPageQueryDTO = {
    limit: query.limit ?? 20,
    offset: query.offset ?? 0,
    sort: query.sort,
    filters: query.filters,
  };
  return useQuery({
    queryKey: walletFeeKeys.list(q),
    queryFn: () => walletFeeApi.list(q),
  });
}

export function useWalletFeeDetailQuery(id: string) {
  return useQuery({
    queryKey: walletFeeKeys.detail(id),
    queryFn: () => walletFeeApi.getDetail(id),
    enabled: !!id,
  });
}

export function useCreateWalletFeeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateFeeConfigInput) => walletFeeApi.create(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: walletFeeKeys.all });
      toast.success("ສ້າງກົດຄ່າທຳນຽມສຳເລັດ");
    },
    onError: () => {
      toast.error("ສ້າງກົດຄ່າທຳນຽມລົ້ມເຫຼວ");
    },
  });
}

export function useUpdateWalletFeeMutation(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateFeeConfigInput) => walletFeeApi.update(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: walletFeeKeys.all });
      qc.invalidateQueries({ queryKey: walletFeeKeys.detail(id) });
      toast.success("ອັບເດດກົດຄ່າທຳນຽມສຳເລັດ");
    },
    onError: () => {
      toast.error("ອັບເດດກົດຄ່າທຳນຽມລົ້ມເຫຼວ");
    },
  });
}
